export default function ValidateUser({ children }) {
	const id = sessionStorage.getItem(process.env.REACT_APP_ID_SESSION);
	let content = '';

	if (id !== null) {
		content = <div>{children}</div>;
	} else {
		window.location.replace('/');
	}
	return content;
}
